export const GET_FLOW_ORDER_STATISTICS = 'GET_FLOW_ORDER_STATISTICS'
export const GET_FLOW_ORDER_STATISTICS_SUCCESS = 'GET_FLOW_ORDER_STATISTICS_SUCCESS'
export const GET_FLOW_ORDER_STATISTICS_FAILURE = 'GET_FLOW_ORDER_STATISTICS_FAILURE'